import React from 'react';
import BuySellCrypto from '../components/BuySellCrypto';

export default function BuySellCryptoPage() {
	return <BuySellCrypto />;
}
